export const camo = [
  {
    number: 'HCM100',
    hasModel: false
  }
]